export const LIST_TYPES = ['numbered-list', 'bulleted-list'];
export const TEXT_ALIGN_TYPES = ['left', 'center'];
export const TOKEN_TYPE = 'token';
export const LINK_TYPE = 'link';
export const HASHTAG_TYPE = 'hashtag';
export const IMAGE_TYPE = 'image';
export const BUTTON_TYPE = 'button';
